/* Who is signed in, and for which agency: GET /agency/profile, shared with
 * every screen. Re-read on a timer so the rail's counts (new requests, join
 * requests) move without a reload. */

import { createContext, useContext } from 'react';
import type { Profile } from '../data/agency';

export interface ProfileState {
  profile: Profile;
  reload: () => Promise<void>;
}

export const ProfileContext = createContext<ProfileState | null>(null);

export function useProfile(): ProfileState {
  const p = useContext(ProfileContext);
  if (!p) throw new Error('useProfile outside the signed-in shell');
  return p;
}

/** OWNER and ADMIN manage the agency; DISPATCHER takes requests and assigns. */
export function canManage(role: string): boolean {
  return role === 'OWNER' || role === 'ADMIN';
}
